import SurveyItemBase from './SurveyItemBase';
export default class SurveyItem extends SurveyItemBase {
    constructor(wrapper) {
        super(wrapper);
        this.init = () => {
        };
    }
}
;
